export default {
  'tour.name': 'Tour name',
  'tour.en.name': 'Tourname Englisch',
  'tour.en.fa.name': 'Tourname Persisch',
  'tour.englishTourName': 'Tourname (auf Englisch)',
  'tour.persianTourName': 'Tourname (auf Persisch)',
  'tour.necessities': 'Notwendigkeiten Englisch',
  'tour.en.necessities': 'Necessities in Englisch',
  'tour.en.fa.necessities': 'Necessities in Persisch',
  'tour.englishNecessities': 'Wichtiges für die Reise (auf Englisch)',
  'tour.persianNecessities': 'Wichtiges für die Reise (auf Persisch)',
  'tour.moneyUnit': 'Geldeinheit',
  'tour.price': 'Preis',
  'tour.setPrice': 'Preis festlegen',
  'tour.type': 'Tourtyp',
  'tour.registerDate': 'Registrierungsdatum',
  'tour.whether': 'Ob',
  'tour.tourCondition': 'Tourzustand',
  'tour.passengerTypes': 'Passagiertypen',
  'tour.choosePassengerTypes': 'Passagiertypen auswählen',
  'tour.capacity': 'Kapazität der Anzahl der Personen in der Tour',
  'tour.duration': 'Tourdauer (Tage)',
  'tour.destination': 'Ziel',
  'tour.destinationCity': 'Zielstadt',
  'tour.destinationCountry': 'Zielland',
  'tour.en.destination': 'Zielname Englisch',
  'tour.en.fa.destination': 'Zielname Persisch',
  'tour.description': 'Bezeichnung',
  'tour.en.description': 'Beschreibung auf Englisch',
  'tour.en.fa.description': 'Beschreibung auf Persisch',
  'tour.englishDescription':
    'Erwähnen Sie die für die Reise erforderlichen Details (in Englisch)',
  'tour.persianDescription':
    'Erwähnen Sie die für die Reise erforderlichen Details (auf Persisch)',
  'tour.name': 'Tour name',
  'tour.en.name': 'Tourname Englisch',
  'tour.en.fa.name': 'Tourname Persisch',
  'tour.englishTourName': 'Tourname (auf Englisch)',
  'tour.persianTourName': 'Tourname (auf Persisch)',
  'tour.necessities': 'Notwendigkeiten Englisch',
  'tour.en.necessities': 'Necessities in Englisch',
  'tour.en.fa.necessities': 'Necessities in Persisch',
  'tour.englishNecessities': 'Wichtiges für die Reise (auf Englisch)',
  'tour.persianNecessities': 'Wichtiges für die Reise (auf Persisch)',
  'tour.moneyUnit': 'Geldeinheit',
  'tour.price': 'Preis',
  'tour.setPrice': 'Preis festlegen',
  'tour.type': 'Tourtyp',
  'tour.registerDate': 'Registrierungsdatum',
  'tour.whether': 'Ob',
  'tour.tourCondition': 'Tourzustand',
  'tour.passengerTypes': 'Passagiertypen',
  'tour.choosePassengerTypes': 'Passagiertypen auswählen',
  'tour.capacity': 'Kapazität der Anzahl der Personen in der Tour',
  'tour.duration': 'Tourdauer (Tage)',
  'tour.destination': 'Ziel',
  'tour.destinationCity': 'Zielstadt',
  'tour.destinationCountry': 'Zielland',
  'tour.en.destination': 'Zielname Englisch',
  'tour.en.fa.destination': 'Zielname Persisch',
  'tour.description': 'Bezeichnung',
  'tour.en.description': 'Beschreibung auf Englisch',
  'tour.en.fa.description': 'Beschreibung auf Persisch',
  'tour.englishDescription':
    'Erwähnen Sie die für die Reise erforderlichen Details (in Englisch)',
  'tour.persianDescription':
    'Erwähnen Sie die für die Reise erforderlichen Details (auf Persisch)',

  'tour.limitaions': 'Einschränkungen',
  'tour.en.limitaions': 'Einschränkungen in Englisch',
  'tour.englishlimitaions': 'Reisebeschränkungen (auf Englisch)',
  'tour.persianlimitaions': 'Reisebeschränkungen (auf Persisch)',
  'tour.departure': 'Abfahrt',
  'tour.departureCity': 'Abfahrt Stadt',
  'tour.departureCountry': 'Abflugland',
  'tour.en.departure': 'Abfahrt',
  'tour.en.fa.departure': 'abreise auf persisch',
  'tour.difficultyRate': 'Reiseschwierigkeiten',
  'tour.departureDate': 'Tourstartzeit',
  'tour.international': 'International',
  'tour.domestic': 'inländisch',
  'tour.addTour': 'Fügen Sie eine neue Tour hinzu',
  'tour.easy': 'Einfach',
  'tour.amature': 'Amatur',
  'tour.normal': 'Normal',
  'tour.hard': 'schwer',
  'tour.veryHard': 'Sehr schwer',
  'tour.road': 'Straße',
  'tour.flight': 'Flug',
  'tour.marine': 'Marine',
  'tour.transportTypes': 'Transportarten',
  'tour.chooseTransportTypes': 'Transportarten auswählen',
  'tour.surpriseTour': 'Überraschungstour',
  'tour.ordinaryTour': 'Gewöhnliche Tour',
  'tour.next': 'Nächster Schritt',
  'tour.home': 'Heim',
  'tour.confirm': 'Bestätigen Sie',
  'tour.previous': 'vorheriger Schritt',
  'tour.active': 'Aktiv',
  'tour.disable': 'Deaktivieren',
  'tour.dollar': 'US Dollar',
  'tour.euro': 'Euro',
  'tour.rial': 'Rial',
  'tour.stepOne': 'Schritt 1',
  'tour.stepTwo': 'Schritt 2',
  'tour.stepThree': 'Schritt 3',
  'tour.stepFour': 'Schritt 4',
  'tour.stepFive': 'Schritt 5',
  'tour.details': 'Einzelheiten',
  'tour.tourDetails': 'Tourdetails',
  'tour.cancel': 'Stornieren',
  'tour.chooseTourType': 'Wählen Sie Ihren Typ',
  'tour.save': 'Speichern',
  'tour.tourDetail': 'Tourinformationen',
  'tour.furtherInformation': 'Weitere Informationen',
  'tour.toddlerinownsitPrice': 'Preis für ein Kleinkind im eigenen Sitz',
  'tour.infantPrice': 'Preis für ein Kleinkind',
  'tour.childPrice': 'Preis für ein Kind',
  'tour.adultPrice': 'Preis für einen Erwachsenen',
  'tour.studentPrice': 'Preis für einen Studenten',
  'tour.seniorcitizenPrice': 'Preis für einen Senioren',
  'tour.bookingDeadline': 'Anmeldeschluss für die Tour',
  'tour.climateType': 'Wetter während der Reise',
  'tour.step': 'Schritt',
  'tour.tourclimateTitle': 'Tour Klima Titel',
  'tour.tourclimateDescription': 'Auswahl des Tourklimas',
  'tour.tourtypeTitle': 'Tourtyp',
  'tour.tourtypeDescription': 'Wählen Sie die Art der Tour',
  'tour.tourtransfertypeTitle': 'Tour-Transfer-Typ',
  'tour.tourtransfertypeDescription': 'Wählen Sie die Art des Tourtransports',
  'tour.tourpassengertypeTitle': 'Reisepassagiertyp ',
  'tour.tourpassengertypeDescription': 'Wählen Sie Ihren Passagiertyp',
  'tour.tourinformationTitle': 'Tourinformationen',
  'tour.tourinformationDescription':
    'Geben Sie die vollständigen Tourinformationen ein',
  'tour.touroverviewTitle': 'Tourübersicht',
  'tour.touroverviewDescription':
    'Überprüfen und bearbeiten Sie die ausgewählten Tourinformationen gründlich und sorgfältig',
  'tour.tourpriceTitle': 'Tourpreis ',
  'tour.overview': 'Überblick ',
  'tour.tourpriceDescription':
    'Geben Sie die Preise für jeden Passagier Ihrer Wahl ein',
  'tour.tourScheduling': 'Tourenplanung',
  'tour.mainTourInformation': 'Haupttourinformationen',
  'tour.tourConditions': 'Tourbedingungen',
  'tour.tourRestrictionsRequirements': 'Tourbeschränkungen und Anforderungen',
  'tour.tourRegistration': 'Touranmeldung',
  'tour.addNewTour': 'Eine neue Tour hinzufügen',
  'tour.tourInformationTemporarilyRecorded':
    'Tourinformationen wurden vorübergehend aufgezeichnet',
  'tour.yourTourSuccessfullyRegistered':
    'Ihre Tour wurde erfolgreich registriert',
  'tour.tourpassengertype': 'Passagiertyp',
  'tour.tourtransfertype': 'Tour-Transfer',
  'tour.tourType': 'Tourtyp',
  'tour.nameen': 'Tourname (auf Englisch)',
  'tour.namefa': 'Tourname (auf Persisch)',
  'tour.bookingDeadLine': 'Anmeldeschluss für die Tour',
  'tour.climateTypes': 'Tour-Klima',
  'tour.limitationsen': 'Reisebeschränkungen (auf Englisch)',
  'tour.limitationsfa': 'Reisebeschränkungen (auf Persisch)',
  'tour.necessitiesen': 'Wichtiges für die Reise (auf Englisch)',
  'tour.necessitiesfa': 'Notwendiges für die Reise (auf Persisch)',
  'tour.descriptionen':
    'Erwähnen Sie die für die Reise erforderlichen Details (in Englisch)',
  'tour.descriptionfa':
    'Erwähnen Sie die für die Reise erforderlichen Details (auf Persisch)',
  'tour.editTourTransferType': 'Informationen zum Tourtransfer bearbeiten',
  'tour.editTourPassengerType':
    'Passagierinformationen und Preise für jeden Passagier bearbeiten',
  'tour.editTourInformation': 'Allgemeine Tourinformationen bearbeiten',
  'tour.tourRegistration': 'Touranmeldung',
  'tour.isActive': 'aktiv',
  'tour.editTourPassengerType': 'Tour-Passagiertyp bearbeiten',
  'tour.editTourTransferType': 'Tour-Transfertyp bearbeiten',
  'tour.editTourInformationType': 'Tourinformationen bearbeiten',
  'tour.editTourPrice': 'Passagierpreis bearbeiten',
  'tour.attachments': 'Anhänge',
  'tour.cancelingRules': 'Stornierungsregeln',
  'tour.endBookingDeadLine': 'Ende der Buchungsfrist',
  'tour.endPrice': 'Endpreis',
  'tour.startPrice': 'Startpreis',
  'tour.endDuration': 'Enddauer',
  'tour.startDuration': 'Startdauer',
  'tour.endDepartureDate': 'Endabreisedatum',
  'tour.startDepartureDate': 'Abreisedatum starten',
  'tour.originterminal': 'Ursprung Terminal',
  'tour.destinationterminal': 'Ziel Terminal',
  'tour.vehicletype': 'Fahrzeugtyp',
  'tour.starttime': 'Startzeit',
  'tour.endtime': 'Endzeit',
  'tour.invalidreturndate': 'Enddatum kleiner als Startdatum',
  'tour.invalidstartdate': 'Das Startdatum liegt über dem Enddatum',
  'tour.facilities': 'Toureinrichtungen',
  'tour.invalidEndTime': 'Eindtijd korter dan begintijd',
  'tour.drafts': 'Entwürfe',
  'tour.useprevioustours': 'Verwendung früherer Touren',
  'tour.Draft': 'Entwurfstouren',
  'tour.creationDate': 'Erstellungsdatum',
  'tour.dateCreatedFrom': 'Erstellungsdatum von',
  'tour.dateCreatedUntil': 'Erstellungsdatum bis',
  'tour.ordering': 'Bestellung',
  'tour.basedTourName': 'Basierend auf dem Tournamen',
  'tour.basedNamePlace': 'Basierend auf dem Namen des Ortes',
  'tour.search': 'Suche nach Name und Ort',
  'tour.facilitynotdeclared': 'Einrichtung ist nicht deklariert',
  'tour.basicinfonotfound': 'Tourinformationen sind nicht angegeben',
  'tour.finaldestination': 'Endziel',
  'tour.insertdraft': 'Entwurf einfügen',
  'tour.updatetdraft': 'Update-Entwurf',
  'tour.ageSuffering': 'Altersleiden',
  'tour.finaldestination': 'Endziel',
  'tour.insertsuccess': 'Die Tour wurde erfolgreich registriert',
  'tour.draftinsertsuccess': 'Der Tourentwurf wurde erfolgreich registriert',
  'tour.inserterror': 'Die Touranmeldung war nicht erfolgreich',
  'tour.updatesuccess': 'Die Tour wurde erfolgreich aktualisiert',
  'tour.draftupdatesuccess': 'Der Tourentwurf wurde erfolgreich aktualisiert',
  'tour.updateerror': 'Das Tour-Update war nicht erfolgreich',
  'tour.deletesuccess': 'Die Tour wurde erfolgreich gelöscht',
  'tour.draftdeletesuccess': 'Der Tourentwurf wurde erfolgreich gelöscht',
  'tour.deleteerror': 'Das Löschen der Tour war nicht erfolgreich',
  'tour.deletedrafttour': 'Löschen Sie den Tourentwurf',
  'tour.deletedrafttourmessage':
    'Sind Sie sicher, dass Sie den Tourentwurf löschen möchten?',
  'tour.male': 'männlich',
  'tour.female': 'weiblich',
  'tour.all': 'alle',
  'tour.changefieldwarning':
    'Wenn in den wichtigen Feldern Änderungen vorgenommen werden, werden die Informationen der nächsten Schritte gelöscht. Klicken Sie hier, um weitere Informationen zu erhalten.',
  'tour.importantfieldsintroduction':
    'Das Anwenden von Änderungen auf die folgenden Felder führt zum Datenverlust der nächsten Formulare',
  'tour.tournotspecified': 'Tourinformationen sind nicht angegeben',
  'tour.stoptype': 'Stopptyp',
  'tour.searchfacilities': 'Suchmöglichkeiten',
  'tour.confirmdata': 'Alle registrierten Informationen werden überprüft',
  'tour.vehiclenamefa': 'lokaler Fahrzeugname',
  'tour.vehiclenameen': 'Englischer Fahrzeugname',
  'tour.transportproviderlocal': 'Lokaler Name des Transportanbieters',
  'tour.transportprovideren': 'Englischer Name des Transportanbieters',
  'tour.addnewtourtype': 'Neuen Tourtyp hinzufügen',
  'tour.submittourtype': 'neuen Tourtyp einreichen',
  'tour.tourtypenamefa': 'Farsi-Name des Tourtyps',
  'tour.tourtypenameen': 'Englischer Name des Tourtyps',
  'tour.tourtypeinsertsuccess': 'Einfügen erfolgreich',
  'tour.tourtypeinserterror': 'Einfügen erfolglos',
  'tour.originairport': 'Herkunftsflughafen',
  'tour.destinationairport': 'Zielflughafen',
  'tour.arrivaldateto': 'Ankunftsdatum',
  'tour.arrivaltimeto': 'Ankunftszeit',
  'tour.nextmovedate': 'nächster Transportbeginn',
  'tour.nextmovetime': 'Startzeit des nächsten Transports',
  'tour.tourimages': 'Tourbilder',
  'tour.viewimages': 'Bilder ansehen',
  'tour.addnewtourfacility': 'Hinzufügen neuer Toureinrichtungen',
  'tour.tourfacilitynamefa': 'Farsi-Name der Toureinrichtungen',
  'tour.tourfacilitynameen': 'Englischer Name der Toureinrichtungen',
  'tour.originterminalfa': 'Lokaler Name des Ursprungsterminals',
  'tour.originterminalen': 'Englischer Name des Ursprungsterminals',
  'tour.destinationterminalfa': 'Lokaler Name des Zielterminals',
  'tour.destinationterminalen': 'Englischer Name des Zielterminals',
  'tour.underreviewing': 'in Prüfung',
  'tour.expired': 'Abgelaufen',
  'tour.residence': 'Residenz',
  'tour.pricepercustomer': 'Preis pro Person',
  'tour.userstours': 'meine Touren',
  'tour.usersalltours': 'alle Touren',
  'tour.usersactivetours': 'aktive Touren',
  'tour.usersexpiredtours': 'abgelaufene Touren',
  'tour.changerequiredfields': 'Ergebnis der Betreiberbewertung anzeigen',
  'tour.requiredreviews': 'erforderliche Bewertungen',
  'tour.rejectionreason': 'Ablehnungsgrund',
  'tour.rejectiondescription': 'Beschreibung der Ablehnung',
  'tour.starttime': 'Startzeit',
  'tour.endtime': 'Endzeit',
  'tour.imageuploadfailed': 'Das Hochladen des Bildes ist fehlgeschlagen',
};
